<template>
  <div class="kakao-ad-wrapper">
    <!-- PC용 광고 (728x90) -->
    <div class="ad-desktop">
      <ins
        class="kakao_ad_area"
        style="display:none;"
        data-ad-unit="DAN-ig8EVrd9iXZyOG96"
        data-ad-width="728"
        data-ad-height="90">
      </ins>
    </div>

    <!-- 모바일용 광고 (320x50) -->
    <div class="ad-mobile">
      <ins
        class="kakao_ad_area"
        style="display:none;"
        data-ad-unit="DAN-4VhowVEw7rvgr9QD"
        data-ad-width="320"
        data-ad-height="50">
      </ins>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'

const adKey = ref(Date.now())

onMounted(() => {
  // Kakao Adfit 스크립트 로드
  if (!document.querySelector('script[src*="ba.min.js"]')) {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = '//t1.daumcdn.net/kas/static/ba.min.js'
    script.async = true
    document.head.appendChild(script)
  } else {
    // 이미 로드된 경우 스크립트 재실행
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = '//t1.daumcdn.net/kas/static/ba.min.js'
    script.async = true
    const oldScript = document.querySelector('script[src*="ba.min.js"]')
    if (oldScript && oldScript.parentNode) {
      oldScript.parentNode.removeChild(oldScript)
    }
    document.head.appendChild(script)
  }
})
</script>

<style scoped>
.kakao-ad-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px 0;
  padding: 4px;
  background: transparent;
  border-radius: 0;
  min-height: 90px;
}

/* PC용 광고 표시 */
.ad-desktop {
  display: block;
  width: 100%;
  text-align: center;
}

/* 모바일용 광고 숨김 */
.ad-mobile {
  display: none;
}

/* 모바일 화면 (768px 이하) */
@media (max-width: 768px) {
  .kakao-ad-wrapper {
    padding: 2px;
    margin: 4px 0;
    min-height: 50px;
  }

  /* PC용 광고 숨김 */
  .ad-desktop {
    display: none;
  }

  /* 모바일용 광고 표시 */
  .ad-mobile {
    display: block;
    width: 100%;
    text-align: center;
  }
}
</style>
